import { jsx as _jsx } from "react/jsx-runtime";
const ConfigContent = ({ children, maxWidth = "auto", style = {} })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "rcb-config-content",
        style: {
            maxWidth: maxWidth === "fixed" ? 1300 : maxWidth,
            ...style
        },
        children: children
    });
};
export { ConfigContent };
